import type { Components, Theme } from '@mui/material'

export const MuiCssBaseline = (theme: Theme): Components['MuiCssBaseline'] => ({
  styleOverrides: {
    html: {
      colorScheme: theme.palette.mode,
      scrollBehavior: 'smooth',
    },
    body: {
      backgroundColor: 'transparent !important',
      '&::before': {
        content: '""',
        position: 'fixed',
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        backgroundImage: theme.palette.gradShell(),
        zIndex: -1,
      },
    },
    '::-webkit-horizontal, ::-webkit-scrollbar': {
      width: '6px',
      padding: 0,
      backgroundColor: 'transparent',
    },
    '::-webkit-scrollbar': {
      height: '4px',
    },
    '::-webkit-scrollbar-thumb': {
      width: '6px',
      backgroundColor: theme.palette.bg4,
      borderRadius: '4px',
      boxShadow: 'inset 0 0 4px rgb(0 0 0 / 5%)',
    },
    '::-webkit-scrollbar-track': {
      border: 'none !important',
      backgroundColor: 'transparent !important',
    },
    'input:-webkit-autofill': {
      webkitBoxShadow: '0 0 0px 1000px white inset',
    },
    '.ltr-input.MuiInputBase-input, .ltr-input .MuiInputBase-input': {
      direction: 'rtl',
      textAlign: 'left',
    },
    button: {
      font: 'inherit',
    },
  },
})
